import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {dataRegister} from "../../services/dataRegister";
import {marketRegister} from "../../services/marketRegister";
import ModalVideo from "../../components/modal-video/component";
import ModalForgotPassword from "../../components/modal-forgotpassword/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class ForgotPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            error: false,
            email: "",
            success: false,
            modal: false
        };
        this._setModal = this._setModal.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        try{
            if(this.props.match.params.email){
                this.setState({email: this.props.match.params.email});
            }
        }catch (e) {}
    }

    _setModal(){
        this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/login");
    }

    _send(){
        if(this._emailValidation(this.state.email)){
            this.setState({isLoading: true});
            let email = {email: this.state.email};
            dataRegister.forgotPassword(salesChannelRegister.get("market"), email).then((item) => {
                if(!item.errors){
                    this.setState({isLoading: false, success: true, email: "", error: false, modal: true});
                }
            }, (error) => {
                this.setState({isLoading: false, success: true, error: false, modal: true});
            });
        }else{
            this.setState({isLoading: false, error: true});
        }
    }

    _back(){
        this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/login");
        /*
        if(this.state.user_type === "reseller"){
            this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() +  "/login/pin/" + "reseller" + this.props.location.search)
        }else{
            this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() +  "/login/pin/" + this.state.email + this.props.location.search)
        }
        */
    }

    _emailValidation(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    _renderButton(){
        if (!this.state.isLoading) {
            return (this._renderText("item_4"));
        } else {
            return (<BeatLoader size={9} color={'#ffffff'} loading={true}/>);
        }
    }

    _renderText(item) {
        return langRegister.get("forgotpassword", item);
    }

    render() {
        return (
            <div>
                {
                    this.state.modal &&
                    <ModalForgotPassword setModal={this._setModal} props={this.props}/>
                }
                <HeaderSignupOne view={"login"} props={this.props}/>
                <div className={Styles.container}>
                    <div className={Styles.title}>
                        {
                            this.state.user_type === "reseller" &&
                            <span>{this._renderText("item_6")}</span>
                        }
                        {
                            this.state.user_type !== "reseller" &&
                            <span>{this._renderText("item_1")}</span>
                        }
                    </div>
                    <div className={Styles.subtitle}>
                        {this._renderText("item_2")}
                    </div>
                    <span className={Styles.inputContainer}>
                        <input
                            className={
                                cx(Styles.input)
                            }
                            type={"email"}
                            placeholder={this._renderText("item_3")}
                            value={this.state.email}
                            onChange={(event) => this.setState({email: event.target.value})}
                        />
                        {
                            this.state.error &&
                            <div className={Styles.inputError}/>
                        }
                    </span>
                    <div onClick={() => this._send()} className={Styles.button}>
                        {this._renderButton()}
                    </div>
                    <div onClick={() => this._back()} className={Styles.backButton}>
                        {this._renderText("item_5")}
                    </div>
                </div>
            </div>
        );
    }
}

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/pages/forgotpassword/component.js